import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { actionGetUsers } from '../../../../redux/action/user'
import { useAppSelector } from '../../../../redux/hooks'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { HttpState } from '../../../../util/model';
import CircularProgress from '@mui/material/CircularProgress';

import './UserList.scss';
import { useParams, Link } from 'react-router-dom';

export default function UserList() {

    const userList = useAppSelector(state => state.user.userList)
    const userListState = useAppSelector(state => state.user.userListState)
    const dispatch = useDispatch();
    const { id } = useParams();
    useEffect(() => {
        dispatch(actionGetUsers() as any);
    }, [dispatch, id]);
    if (userListState === HttpState.Progress) {
        return (
	    <div className="UserList UserList-center">
                <CircularProgress />
            </div>
	);
    }
    return (
        <div className="UserList">
            <Typography variant="h5">User List</Typography>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Email</TableCell>
                            <TableCell>UserType</TableCell>
                            <TableCell>Enabled</TableCell>
                            <TableCell>Alert</TableCell>
                            <TableCell>Min Period (sec) to Alert</TableCell>
                            <TableCell>Max Power (dBm) to Alert</TableCell>
                            <TableCell>Detail</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {userListState === HttpState.Success && userList.map((user) => (
                            <TableRow
                                key={user._id}
                                selected={id === user._id}
                            >
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{user.usertype}</TableCell>
                                <TableCell>{user.enabled.toString()}</TableCell>
                                {(!user.alertL1) && (!user.alertL2) && <TableCell>None</TableCell>}
                                {user.alertL1 && (!user.alertL2) && <TableCell>L1</TableCell>}
                                {(!user.alertL1) && user.alertL2 && <TableCell>L2</TableCell>}
                                {user.alertL1 && user.alertL2 && <TableCell>L1/L2</TableCell>}
                                <TableCell>{user.minPeriod}</TableCell>
                                <TableCell>{user.maxPower}</TableCell>
                                <TableCell>
                                    <IconButton size="small" component={Link} to={`/#user/${user._id}`}>
                                        <EditIcon />
                                    </IconButton >
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


        </div>
    )
}
